module.exports = __webpack_public_path__ + "fonts/typicons.a509074c88f07e40a8d2f158c4fcdda8.eot";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/typicons.eot
// module id = 148
// module chunks = 0